<template>  
  <v-container fluid grid-list-lg>
    <v-layout row wrap>      
      <v-flex lg12 xs12>
        <v-card>
          <v-toolbar color="blue lighten-4" dense cad flat>
            <span class="caption">Traffic Pendaftar</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="init()"><v-icon>refresh</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-0" style="min-height:300px">
            <template v-if="showChart1">
              <echart :option="option1"></echart>
            </template>            
          </v-card-text>          
        </v-card>   
      </v-flex>
      <v-flex lg4 xs12>
        <v-card>
          <v-card-text class="pa-0">
            
          </v-card-text>
        </v-card>   
      </v-flex>      
    </v-layout>
  </v-container>  
</template>
<script>
import Echart from '@/components/chart/echart';  
import User  from '@/util/models/User';
import Model from '@/apps/admin/models/Dashboard'

const  model = new Model();

export default {
  components: {
    Echart
  },
  props : {
    toggle_tingkat : Array
  },
  data:()=>({    
    roles : User.roles(), 
    showChart1 : false,
    option1 : {
      title: {

      },                  
      tooltip: {
          trigger: 'axis'
      },
      legend: {
          id   : [1,2,3],
          data : ['SD','SMP','MA']
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis: {
          type: 'category',            
          boundaryGap: false,
          data: []
      },
      yAxis: {
          type: 'value'
          //data:[]
      },
      series: [
        {name:'SD',data:[],type:'line', total:0},
        {name:'SMP',data:[],type:'line', total:0},
        {name:'MA',data:[],type:'line', total:0},
      ]
    }
  }),
  watch:{    
  },
  computed: {                  
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      this.showChart1 = false;            
      model.chartStatistic().then(data=>{                   
        this.option1.xAxis.data = [];
        this.option1.series.forEach(ser=>{
          ser.data = []; 
          ser.total = 0;
        });        

        /*data.forEach((item, n)=>{          
          this.option1.xAxis.data.push(item.day_month);
          this.option1.series[0].data.push(item.jumlah);
        });*/
        
        data.forEach((item, n)=>{                    
          if(n === 0){
            this.option1.xAxis.data.push('start');
            this.option1.series.forEach(ser=>{
              ser.data.push(0);
            });
          }
          if(!this.option1.xAxis.data.find(x=>x=== item.day_month)){
            this.option1.xAxis.data.push(item.day_month);
            this.option1.series.forEach(ser=>{
              ser.data.push(0);
            });
          }          
        });

        data.forEach((item)=>{
          var indx = this.option1.xAxis.data.findIndex(x=>x === item.day_month);
          let indy = this.option1.legend.id.findIndex(x=>x === item.tingkat_id);
          if(indy >= 0 && this.option1.series[indy]){            
            this.option1.series[indy].total += parseFloat(item.jumlah);                        
            this.option1.series[indy].data[indx] = this.option1.series[indy].total;
          }
        });      

        
        this.option1.series.forEach((ser, i)=>{
          ser.data.forEach((dat,j)=>{                            
            if(j>0 && ser.data[j]== 0){                  
              ser.data[j] = ser.data[j-1];
            }            
          });
        });
        
        this.showChart1 = true;
      });                  
    }
  }
};
</script>

